<div class="container--padding">
  <h1 class="text-center mb-5 mt-5" translate>Choose your path</h1>
  <div class="row">
    <div class="col-xl-6 col-lg-6 col-md-6">
      <div class="create__path__box">
        <span class="path__icon icon--picture"></span>
        <h2 class="mt-3">
          {{ "Create an experience from scratch" | translate }}
        </h2>
        <p>{{ "Create an experience from scratch" | translate }}</p>
        <button
          (click)="createExperience()"
          class="button button--purple button--big listing--button mt-4"
          [disabled]="loader"
        >
          <span *ngIf="loader" type="button"
            ><span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            <span>{{ "Loading" | translate }}</span></span
          ><span *ngIf="!loader">{{ "Get started" | translate }}</span>
        </button>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6">
      <div class="create__path__box">
        <span class="path__icon icon--facebook"></span>
        <h2 class="mt-3">{{ "Import from facebook" | translate }}</h2>
        <p>{{ "Import path" | translate }}</p>
        <button
          routerLink="/import"
          class="button button--blue button--big listing--button mt-4"
          type="button"
        >
          {{ "Import button" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
